import { VerifiedStateEnum } from 'libs/gb-front/shared/models/shared.models'

/**
 * Interface for the 'SelectedProfile' data
 */
export interface ProfileEntity {
  additional_info_actioned?: boolean
  additional_info_required?: boolean
  address?: string
  announcement_notifications_option?: boolean
  auction?: string
  company_address?: string
  company_name?: string
  complete_profile_prompted?: boolean
  credit_card_required?: CreditCardRequired
  custom_registration_values?: CustomValuesEntity[]
  display_anonymous?: boolean
  email?: string
  email_editable?: boolean
  email_verified?: string
  enable_verification?: boolean
  favourite_items?: string[]
  favourite_items_count?: number
  first_name?: string | null
  gift_aid_consented?: boolean
  has_vouchers?: boolean
  has_event_tickets?: boolean
  has_event_ticket_purchases?: boolean
  invite_email?: string | null
  invite_phone_number?: string | null
  is_social_login?: boolean
  last_name?: string | null
  linked_tables?: LinkedTablesEntity[]
  notification_subscribed?: boolean
  outbid_notifications_option?: boolean
  password_required?: boolean
  phone_number?: string
  phone_number_editable?: boolean
  phone_number_unsubscribed?: boolean
  phone_number_verified?: string
  phone_number_verified_state?: VerifiedStateEnum
  preferred_contact?: string
  profile?: string
  profile_validated?: boolean
  stripe_customer?: string
  table_number?: string
  terms_and_conditions_accepted?: boolean
  title?: string
  type?: ProfileTypeEnum
  user?: ProfileUserEntity
  uuid: string
  volunteer?: boolean
}

export interface ProfileUserEntity {
  email: string | null
  email_verified_state: string
  first_name: string
  last_name: string
  phone_number: string | null
  phone_number_verified_state: VerifiedStateEnum
  uuid: string
}

export interface CompleteProfilePayload extends ProfileEntity {
  password?: string
}

export interface UpdateProfilePayload {
  profile: CompleteProfilePayload
  showSnackBar: boolean
  snackBarMessage?: string
  shouldRedirect: boolean
  dialog: boolean
  hideLoader?: boolean
}

export enum ProfileTypeEnum {
  Guest = 'guest',
  Volunteer = 'volunteer',
}

export type CreditCardRequired = 'You must add a payment method to your profile.' | ''

export interface CustomValuesEntity {
  auction: string
  custom_field: string
  profile: string
  uuid: string
  value: string
}

export interface CreateCustomValuePayload {
  auction: string
  custom_field: string
  profile: string
  value: string
}

export interface NotificationSettingsPayload {
  isSubscribed?: boolean
  showPoppers?: boolean
}

export interface LinkedTablesEntity {
  table_name: string
  table_number: string
  ticket_number: string
}
